import { IDepartmentOptions } from 'src/utils/interfaces/user';
import Item from './item/item';
import React from 'react';
import { useLocalization } from 'src/utils/useLocalization';

import './contact.scss';

export interface IContactInformation {
    name: string;
    isAdmin: boolean;
    phone?: string;
    email?: string;
    fax?: string;
    showDepartment?: boolean;
    departmentOptions?: IDepartmentOptions;
}

const DepartmentTable: React.FC<{
    contactInformation: IContactInformation;
}> = ({ contactInformation }) => {
    const { departmentInfo } = useLocalization();

    return (
        <div className={'contact-dept-table'}>
            <div className='c-table-wrapper u-mt-small c-table-wrapper--no-scroll c-table--narrow'>
                <table role='table'>
                    <thead>
                        <tr role='row'>
                            <th scope='col'>{departmentInfo.DEPT_LABEL}</th>
                            <th scope='col'>{departmentInfo.OPTION_LABEL}</th>
                        </tr>
                    </thead>
                    {contactInformation.departmentOptions ? (
                        <tbody>
                            {contactInformation.departmentOptions.credit ? (
                                <tr role='row'>
                                    <td>{departmentInfo.CREDIT}</td>
                                    <td>
                                        {
                                            contactInformation.departmentOptions
                                                .credit
                                        }
                                    </td>
                                </tr>
                            ) : null}
                            {contactInformation.departmentOptions.funding ? (
                                <tr role='row'>
                                    <td>{departmentInfo.FUNDING}</td>
                                    <td>
                                        {
                                            contactInformation.departmentOptions
                                                .funding
                                        }
                                    </td>
                                </tr>
                            ) : null}
                            {contactInformation.departmentOptions.lease ? (
                                <tr role='row'>
                                    <td>{departmentInfo.LEASE}</td>
                                    <td>
                                        {
                                            contactInformation.departmentOptions
                                                .lease
                                        }
                                    </td>
                                </tr>
                            ) : null}
                            {contactInformation.departmentOptions
                                .customerService ? (
                                <tr role='row'>
                                    <td>{departmentInfo.CUSTOMER_SERVICE}</td>
                                    <td>
                                        {
                                            contactInformation.departmentOptions
                                                .customerService
                                        }
                                    </td>
                                </tr>
                            ) : null}
                            {contactInformation.departmentOptions
                                .dealerSupport ? (
                                <tr role='row'>
                                    <td>{departmentInfo.DEALER_SUPPORT}</td>
                                    <td>
                                        {
                                            contactInformation.departmentOptions
                                                .dealerSupport
                                        }
                                    </td>
                                </tr>
                            ) : null}
                            {contactInformation.departmentOptions
                                .deTechService ? (
                                <tr role='row'>
                                    <td>{departmentInfo.DE_TECH_SUPPORT}</td>
                                    <td>
                                        {
                                            contactInformation.departmentOptions
                                                .deTechService
                                        }
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    ) : null}
                </table>
            </div>
        </div>
    );
};

const Contact: React.FC<{ contactInformation: IContactInformation }> = ({
    contactInformation,
}) => {
    const { contactInfo } = useLocalization();

    const itemNameClass = contactInformation.isAdmin
        ? 'item_name_admin'
        : 'item_name';
    return (
        <div className={'contact-info_item'}>
            <div className='title'>
                {contactInformation.isAdmin &&
                (contactInformation.name || contactInformation.email) ? (
                    <span className='admin'>{contactInfo.ADMIN_LABEL}</span>
                ) : null}
                <span className={itemNameClass}>{contactInformation.name}</span>
            </div>
            {contactInformation.phone ? (
                <Item
                    label={contactInfo.PHONE_LABEL}
                    info={contactInformation.phone}
                />
            ) : null}
            {contactInformation.email ? (
                <Item
                    label={contactInfo.EMAIL_LABEL}
                    info={contactInformation.email}
                />
            ) : null}
            {contactInformation.fax ? (
                <Item
                    label={contactInfo.FAX_LABEL}
                    info={contactInformation.fax}
                />
            ) : null}

            {contactInformation.showDepartment ? (
                <DepartmentTable contactInformation={contactInformation} />
            ) : null}
        </div>
    );
};

export default Contact;
